import { render, staticRenderFns } from "./ItemStoreSpecial.vue?vue&type=template&id=9410a8b2&"
import script from "./ItemStoreSpecial.vue?vue&type=script&lang=js&"
export * from "./ItemStoreSpecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\bensz\\Documents\\Frontend Studios\\plentyDevTool\\stabiloVueTheme\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9410a8b2')) {
      api.createRecord('9410a8b2', component.options)
    } else {
      api.reload('9410a8b2', component.options)
    }
    module.hot.accept("./ItemStoreSpecial.vue?vue&type=template&id=9410a8b2&", function () {
      api.rerender('9410a8b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/itemList/ItemStoreSpecial.vue"
export default component.exports